"use client";

import chroma from "chroma-js";
import makeBlockie from "ethereum-blockies-base64";
import { extractColors } from "extract-colors";
import { useEffect, useState } from "react";
const COLORS_HUE_RANGE = 0.25;
function isCloseToBlackOrWhite(color) {
  const chromaColor = chroma(color);
  return chromaColor.luminance() < 0.05 || chromaColor.luminance() > 0.95;
}
function mapProminentColors(input, colorsAmount, excludeBlackAndWhite = true) {
  const colors = (Array.isArray(input) ? input : [input]).map(color => color.toLowerCase());
  const filteredColors = excludeBlackAndWhite ? colors.filter(color => !isCloseToBlackOrWhite(color)) : colors;
  if (filteredColors.length === 0) {
    return [];
  }
  return chroma.scale(
  // If there is only one color, we generate two colors to add some contrast
  filteredColors.length === 1 ? [chroma(filteredColors[0]).darken(COLORS_HUE_RANGE), chroma(filteredColors[0]).brighten(COLORS_HUE_RANGE)] : filteredColors).colors(colorsAmount);
}
export const useProminentColors = (image, options = {}) => {
  const [prominentColors, setProminentColors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const saveProminentColors = async () => {
      setIsLoading(true);
      try {
        const extractedColors = await extractProminentColors(image, options);
        if (extractedColors) {
          setProminentColors(extractedColors);
        }
      } finally {
        setIsLoading(false);
      }
    };
    saveProminentColors();
  }, [image, options]);
  return {
    prominentColors,
    isLoading
  };
};
export const extractProminentColors = async (inputImage, {
  fallbackSeed,
  excludeBlackAndWhite = true,
  ...options
} = {}) => {
  const image = inputImage ?? (fallbackSeed ? makeBlockie(fallbackSeed) : undefined);
  if (!image) {
    return;
  }
  const foundColors = await extractColors(image, options);
  const refinedColors = foundColors.sort((a, b) => b.area - a.area).map(color => color.hex);
  const prominentColors = mapProminentColors(refinedColors, foundColors.length, excludeBlackAndWhite);
  return prominentColors;
};